import React, { useState } from "react";

/** House charcoal for toggle bars; the accent carries the pillar / topic colour. */
export const TOGGLE_CHARCOAL = "#2D2C31";

/**
 * A neat page section behind a charcoal toggle bar. Always starts CLOSED — the user
 * opens it. `accent` is the pillar colour (stripe + chevron); `open`/`onToggle`
 * make it controlled, otherwise it keeps its own state.
 */
export default function ToggleSection({ title, subtitle, aside, accent = "#6c757d", open, onToggle, children, className = "mb-2" }) {
  const [own, setOwn] = useState(false);
  const isOpen = open !== undefined ? open : own;
  const toggle = onToggle || (() => setOwn((v) => !v));

  return (
    <div className={`shadow-sm ${className}`} style={{ borderRadius: 6, overflow: "hidden", border: `1px solid ${TOGGLE_CHARCOAL}` }}>
      <button
        type="button"
        onClick={toggle}
        aria-expanded={isOpen}
        className="btn w-100 text-start d-flex align-items-center gap-2 py-2 px-3 border-0 rounded-0 text-white"
        style={{ backgroundColor: TOGGLE_CHARCOAL, borderLeft: `6px solid ${accent}` }}
      >
        <i className={`bi ${isOpen ? "bi-chevron-down" : "bi-chevron-right"}`} style={{ color: accent }} />
        <span className="flex-grow-1">
          <span className="fw-bold">{title}</span>
          {subtitle && <span className="small ms-2" style={{ color: "rgba(255,255,255,0.7)" }}>{subtitle}</span>}
        </span>
        {aside && <span className="small text-nowrap" style={{ color: "rgba(255,255,255,0.85)" }}>{aside}</span>}
      </button>
      {isOpen && <div className="bg-white px-3 pb-3 pt-3">{children}</div>}
    </div>
  );
}
